import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import { Breadcrumb } from "@themesberg/react-bootstrap";
import {
  Alert,
  Button,
  Descriptions,
  Form,
  Input,
  Radio,
  Select,
  Tag,
  message,
} from "antd";
import notificationApi from "../../api/notificationApi";

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 10 },
};

const validateMessages = {
  required: "${label} is required!",
};

const LIKE_TYPE = {
  CONFESSION: "confession",
  QUOTE_MATCH: "quoteMatch",
};

function TestLikeNotification() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState();
  const [type, setType] = useState(LIKE_TYPE.CONFESSION);

  const onFinish = (values) => {
    setLoading(true);
    setResult(undefined);
    notificationApi
      .triggerTestLike({
        type: values.type,
        toUserId: values.toUserId?.trim(),
        fromUserId: values.fromUserId?.trim() || undefined,
        confessionId:
          values.type === LIKE_TYPE.CONFESSION
            ? values.confessionId?.trim()
            : undefined,
        locale: values.locale,
      })
      .then((res) => {
        setLoading(false);
        setResult(res?.data);
        message.success("Like notification pushed!");
      })
      .catch((err) => {
        setLoading(false);
        message.warn(
          err?.response?.data?.message ||
            err?.message ||
            "Trigger like notification failed"
        );
      });
  };

  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">
          <Breadcrumb
            className="d-none d-md-inline-block"
            listProps={{
              className: "breadcrumb-dark breadcrumb-transparent",
            }}
          >
            <Breadcrumb.Item>
              <FontAwesomeIcon icon={faHome} />
            </Breadcrumb.Item>
            <Breadcrumb.Item active>Test Like Notification</Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      <Alert
        className="mb-4"
        type="info"
        showIcon
        message="Test only, nothing is liked for real"
        description="This pushes the like notification straight to the target user. No like row is created and no like counter is changed."
      />

      <Form
        {...layout}
        form={form}
        name="test-like-notification"
        onFinish={onFinish}
        validateMessages={validateMessages}
        initialValues={{ type: LIKE_TYPE.CONFESSION, locale: "en" }}
      >
        <Form.Item name="type" label="Like type">
          <Radio.Group onChange={(e) => setType(e.target.value)}>
            <Radio.Button value={LIKE_TYPE.CONFESSION}>
              Confession like
            </Radio.Button>
            <Radio.Button value={LIKE_TYPE.QUOTE_MATCH}>
              Quote match like
            </Radio.Button>
          </Radio.Group>
        </Form.Item>

        <Form.Item
          name="toUserId"
          label="To UserID"
          extra="User that receives the notification"
          rules={[{ required: true }]}
        >
          <Input placeholder="uuid of the user to notify" />
        </Form.Item>

        <Form.Item
          name="fromUserId"
          label="From UserID"
          extra="User the like comes from, leave empty to use your own admin account"
        >
          <Input placeholder="uuid of the liker (optional)" />
        </Form.Item>

        {type === LIKE_TYPE.CONFESSION && (
          <Form.Item
            name="confessionId"
            label="ConfessionID"
            extra="Confession the notification opens when tapped"
            rules={[{ required: true }]}
          >
            <Input placeholder="uuid of the confession" />
          </Form.Item>
        )}

        <Form.Item name="locale" label="Locale">
          <Select style={{ width: 120 }}>
            <Select.Option value="en">en</Select.Option>
            <Select.Option value="vi">vi</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 6 }}>
          <Button loading={loading} type="primary" htmlType="submit">
            Trigger like
          </Button>
        </Form.Item>
      </Form>

      {result && (
        <Descriptions
          title="Last trigger"
          layout="vertical"
          bordered
          column={2}
        >
          <Descriptions.Item label="Type">{result.type}</Descriptions.Item>
          <Descriptions.Item label="Pushed">
            {result.pushed ? (
              <Tag color="green">pushed</Tag>
            ) : (
              <Tag color="red">skipped</Tag>
            )}
          </Descriptions.Item>
          <Descriptions.Item label="From">
            {result.fromUserDisplayName} ({result.fromUserId})
          </Descriptions.Item>
          <Descriptions.Item label="To">
            {result.toUserDisplayName} ({result.toUserId})
          </Descriptions.Item>
          {result.confessionId && (
            <Descriptions.Item label="Confession">
              {result.confessionId}{" "}
              {result.confessionExists ? (
                <Tag color="green">exists</Tag>
              ) : (
                <Tag color="orange">not found, deep link will fail</Tag>
              )}
            </Descriptions.Item>
          )}
          <Descriptions.Item label="Locale">{result.locale}</Descriptions.Item>
        </Descriptions>
      )}
    </>
  );
}

export default TestLikeNotification;
